module.exports = __webpack_public_path__ + "img/new-section-tag.7486b5af.png";